import React, { useEffect } from "react";
import dayjs from "dayjs";

import { styled } from "@mui/styles";
import {
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  useMediaQuery,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import Body from "./body";
import { minWidth, width } from "@mui/system";
require("dayjs/locale/th");
dayjs.locale("th");

const useStyles = makeStyles((theme) => ({
  DivCoverReturn: {
    width: "100%",
    height: "calc(100% - 30px)",
  },

  partOfAllCard: {
    width: "100%",
    height: "calc(100% - 100px)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "15px",
    overflow: "hidden",
    overflowY: "auto",
    paddingTop: "20px",
    ["&::-webkit-scrollbar"]: {
      width: "10px",
      [theme.breakpoints.down("lg")]: {
        display: "none",
      },
    },
    ["&::-webkit-scrollbar-thumb"]: {
      backgroundColor: theme.palette.primary.main,
      borderRadius: "3px",
    },
  },
  TextNoBooking: {
    fontSize: "30px",
    textAlign: "center",
  },
  Grid: {
    width: "95%",
  },
  TableRow: {
    ["&:hover"]: {
      cursor: "pointer",
    },
  },
}));

const TextHeader = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  fontWeight: 600,
  color: theme.palette.text["secondary"],
}));

const CustomTableHead = ({ columns }) => (
  <TableHead
    sx={{
      "& .MuiTableCell-root:first-of-type": {
        borderTopLeftRadius: "8px",
        borderBottomLeftRadius: "8px",
      },
      "& .MuiTableCell-root:last-of-type": {
        borderTopRightRadius: "8px",
        borderBottomRightRadius: "8px",
      },
    }}
  >
    <TableRow
      sx={{
        "& .MuiTableCell-root": {
          borderBottom: "none",
          borderTop: "none",
        },
      }}
    >
      {columns.map((column) => (
        <TableCell
          key={column.id}
          style={{
            width: column.width,
            background: "#f4f6f8",
            position: "sticky",
            top: 0,
            zIndex: 1,
          }}
        >
          <TextHeader>{column.label}</TextHeader>
        </TableCell>
      ))}
    </TableRow>
  </TableHead>
);

const CustomTableFooter = ({
  count,
  rowsPerPage,
  page,
  onPageChange,
  onRowsPerPageChange,
}) => (
  <tfoot>
    <TableRow
      sx={{
        "& .MuiTableCell-root": {
          borderBottom: "none",
          borderTop: "none",
        },
      }}
    >
      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 50, 100]}
        colSpan={9}
        count={count}
        rowsPerPage={rowsPerPage}
        page={page}
        slotProps={{
          select: {
            "aria-label": "rows per page",
          },
          actions: {
            showFirstButton: true,
            showLastButton: true,
          },
        }}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        style={{
          position: "sticky",
          bottom: 0,
          background: "white",
          zIndex: 1,
        }}
      />
    </TableRow>
  </tfoot>
);

const HeaderFooter = ({
  columns,
  listAllBooking,
  listBookingIsSuccess,
  listBookingNotSuccess,
  showHistory,
  typeOfBooking,
  onClickCardHandler,
  deliverySampleStatus,
}) => {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("md"));

  // const emptyRows =
  //   page > 0
  //     ? Math.max(
  //         0,
  //         (1 + page) * rowsPerPage -
  //           (showHistory === 0
  //             ? listBookingNotSuccess
  //             : listBookingIsSuccess
  //           ).length
  //       )
  //     : 0;

  const emptyRows =
    page > 0
      ? Math.max(
          0,
          (1 + page) * rowsPerPage -
            ((showHistory !== undefined &&
            listBookingNotSuccess &&
            listBookingIsSuccess)
              ? showHistory === 0
                ? listBookingNotSuccess.length
                : listBookingIsSuccess.length
              : listAllBooking.length)
        )
      : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    setPage(0);
  }, [deliverySampleStatus, showHistory]);
  
  return isMobile ? (
    <div className={`${classes.DivCoverReturn}`}>
      <Table>
        <CustomTableFooter
          count={
            showHistory !== undefined &&
            listBookingNotSuccess &&
            listBookingIsSuccess
              ? showHistory === 0
                ? listBookingNotSuccess.length
                : listBookingIsSuccess.length
              : listAllBooking.length
            // showHistory === 0
            //   ? listBookingNotSuccess.length
            //   : listBookingIsSuccess.length
          }
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
        {(!showHistory &&
        !listBookingNotSuccess &&
        !listBookingIsSuccess) ? (
          listAllBooking && listAllBooking.length > 0 ? (
            <TableBody
              style={{
                height: "100%",
                overflow: "auto",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {(rowsPerPage > 0
                ? listAllBooking.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                : listAllBooking
              ).map((booking, index) => (
                <Body
                  key={index}
                  bookingText={booking}
                  typeOfBooking={typeOfBooking}
                  onClickCardHandler={onClickCardHandler}
                />
              ))}
              {emptyRows > 0 && (
                <tr style={{ height: 41 * emptyRows }}>
                  <td colSpan={3} aria-hidden />
                </tr>
              )}
            </TableBody>
          ) : (
            <Grid item xs={12} style={{ textAlign: "center" }}>
              <Typography style={{ fontSize: "24px" }}>ไม่มีรายการ</Typography>
            </Grid>
          )
        ) : showHistory === 0 ? (
          listBookingNotSuccess && listBookingNotSuccess.length > 0 ? (
            <TableBody
              style={{
                height: "100%",
                overflow: "auto",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {(rowsPerPage > 0
                ? listBookingNotSuccess.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                : listBookingNotSuccess
              ).map((booking, index) => (
                <Body
                  key={index}
                  bookingText={booking}
                  typeOfBooking={typeOfBooking}
                  onClickCardHandler={onClickCardHandler}
                />
              ))}
              {emptyRows > 0 && (
                <tr style={{ height: 41 * emptyRows }}>
                  <td colSpan={3} aria-hidden />
                </tr>
              )}
            </TableBody>
          ) : (
            <Grid item xs={12} style={{ textAlign: "center" }}>
              <Typography style={{ fontSize: "24px" }}>ไม่มีรายการ</Typography>
            </Grid>
          )
        ) : showHistory === 1 ? (
          listBookingIsSuccess && listBookingIsSuccess.length > 0 ? (
            <TableBody
              style={{
                height: "100%",
                overflow: "auto",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {(rowsPerPage > 0
                ? listBookingIsSuccess.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                : listBookingIsSuccess
              ).map((booking, index) => (
                <Body
                  key={index}
                  bookingText={booking}
                  typeOfBooking={typeOfBooking}
                  onClickCardHandler={onClickCardHandler}
                />
              ))}
              {emptyRows > 0 && (
                <tr style={{ height: 41 * emptyRows }}>
                  <td colSpan={3} aria-hidden />
                </tr>
              )}
            </TableBody>
          ) : (
            <Grid item xs={12} style={{ textAlign: "center" }}>
              <Typography style={{ fontSize: "24px" }}>ไม่มีรายการ</Typography>
            </Grid>
          )
        ) : null}
      </Table>
    </div>
  ) : (
    // !isMobile
    <div className={`${classes.DivCoverReturn}`}>

      {(showHistory === undefined &&
        !listBookingNotSuccess &&
        !listBookingIsSuccess) &&
        (listAllBooking && listAllBooking.length > 0 ? (
          <TableContainer
            style={{
              // height: '550px',
              height: "100%",
              overflow: "auto",
            }}
          >
            <Table stickyHeader>
              <CustomTableHead columns={columns} />
              <TableBody>
                {(rowsPerPage > 0
                  ? listAllBooking
                      // .toReversed()
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                  : listAllBooking
                ).map((booking, index) => (
                  <Body
                    key={index}
                    bookingText={booking}
                    typeOfBooking={typeOfBooking}
                    onClickCardHandler={onClickCardHandler}
                  />
                ))}
                {emptyRows > 0 && (
                  <tr style={{ height: 41 * emptyRows }}>
                    <td colSpan={3} aria-hidden />
                  </tr>
                )}
              </TableBody>
              <CustomTableFooter
                count={listAllBooking.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Table>
          </TableContainer>
        ) : (
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <Typography style={{ textAlign: "center", fontSize: "24px" }}>
              ไม่มีรายการ
            </Typography>
          </Grid>
        ))}
      {showHistory === 0 &&
        (listBookingNotSuccess && listBookingNotSuccess.length > 0 ? (
          <TableContainer
            style={{
              // height: '550px',
              height: "100%",
              overflow: "auto",
            }}
          >
            <Table stickyHeader>
              <CustomTableHead columns={columns} />
              <TableBody>
                {(rowsPerPage > 0
                  ? listBookingNotSuccess
                      // .toReversed()
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                  : listBookingNotSuccess
                ).map((booking, index) => (
                  <Body
                    key={index}
                    bookingText={booking}
                    typeOfBooking={typeOfBooking}
                    onClickCardHandler={onClickCardHandler}
                  />
                ))}
                {emptyRows > 0 && (
                  <tr style={{ height: 41 * emptyRows }}>
                    <td colSpan={3} aria-hidden />
                  </tr>
                )}
              </TableBody>
              <CustomTableFooter
                count={listBookingNotSuccess.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Table>
          </TableContainer>
        ) : (
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <Typography style={{ textAlign: "center", fontSize: "24px" }}>
              ไม่มีรายการ
            </Typography>
          </Grid>
        ))}

      {showHistory === 1 &&
        (listBookingIsSuccess && listBookingIsSuccess.length > 0 ? (
          <TableContainer
            style={{
              // height: '550px',
              height: "100%",
              overflow: "auto",
            }}
          >
            <Table stickyHeader>
              <CustomTableHead columns={columns} />
              <TableBody>
                {(rowsPerPage > 0
                  ? listBookingIsSuccess
                      // .toReversed()
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                  : listBookingIsSuccess
                ).map((booking, index) => (
                  <Body
                    key={index}
                    bookingText={booking}
                    typeOfBooking={typeOfBooking}
                    onClickCardHandler={onClickCardHandler}
                  />
                ))}
                {emptyRows > 0 && (
                  <tr style={{ height: 41 * emptyRows }}>
                    <td colSpan={3} aria-hidden />
                  </tr>
                )}
              </TableBody>
              <CustomTableFooter
                count={listBookingIsSuccess.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Table>
          </TableContainer>
        ) : (
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <Typography style={{ textAlign: "center", fontSize: "24px" }}>
              ไม่มีรายการ
            </Typography>
          </Grid>
        ))}
    </div>
  );
};

export default HeaderFooter;
